/*
 * Copyright (c) 2022. Nedaware SL
 */

import {FilterInterface, InvalidFilterProperty, InvalidFilterValue} from "../../api/filter-interface";
import {InternalPropertyMap} from "../basic-entity-interface/mapping-internal";

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */

/**
 * This filter communicates with the boolean filter for api platform. Sends a parameter of the type:
 *      property=<true|false>.
 *
 * It accepts boolean data, the strings "true", "false", "0", "1" and the numbers 0 or 1 exclusively
 */
export class BooleanFilter implements FilterInterface {
    dataToParams(property: InternalPropertyMap | null, data: any[] | any): { [p: string]: string | string[] } {
        if (property == null) {
            throw new InvalidFilterProperty(property, "the property cannot be null");
        }
        if (typeof data !== "boolean") {
            if (["true", "false", "0", "1", 0, 1].includes(data)) {
                data = data === "true" || data === "1" || data === 1;
            } else {
                throw new InvalidFilterValue(data, 'the passed value is not valid.');
            }
        }
        return {[property.paramName]: data ? 'true' : 'false'};
    }
}
